export interface LoginProps {
    username: string;
    password: string;
}

export interface SignupProps {
    username: string;
    email: string;
    password: string;
    role: string;
}

// export const apiUrl = 'https://api.mazola.com.sa/api/v2';
export const apiUrl = 'https://mazola-api.onrender.com/api/v2';

export const apiUrl1 = 'https://api.mazola.com.sa/api/v1';